import { SELECT_DATA, SELECT_LIST, SELECT_LIST_RESPONSIVE } from "../constants/select";

import { Grid, Typography } from "@mui/material";
import Icon from "../../shared/components/icon/icon";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

import { TabsMobile } from "../../tabs-mobile/tabs-mobile";
import { MenuProfile } from "../../menu-profile/menu-profile";
import { useEffect, useState } from "react";
import ModalQR from "../../shared/components/modal-qr/modal-qr";

export function Menu({ branches, branch, changeSection, section }: { branches: any, branch: number, changeSection: (sectionChange: number) => void, section: number }) {

    const [modalQR, showQR] = useState<boolean>(false);
    const [daysLeft, setDaysLeft] = useState(25);

    useEffect(() => {
        const startDate = new Date("March 10, 2024");
        const endDate = new Date(startDate.getTime() + 10 * 24 * 60 * 60 * 1000);

        const intervalId = setInterval(() => {
            const now = new Date();
            const difference = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
            if (difference <= 0) {
                clearInterval(intervalId);
                setDaysLeft(0);
            } else {                
                setDaysLeft(difference);
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    
    let selectList = SELECT_LIST;
    const filteredBranch = SELECT_DATA.items.find((item: any) => item.id === branch);
    if(filteredBranch && filteredBranch.teacher_changes){
        selectList = [...SELECT_LIST,{ id: 5, text: 'Cambios y modificaciones', name: 'Cambios y modificaciones', class: 'list-item', icon: 'checklist', 'iconWidth': 22, 'iconHeight': 22, 'iconHeightMobile': 22 }]
    }
    console.log(branches,branch,filteredBranch,selectList);
    SELECT_DATA.items = branches;
    SELECT_DATA.value = String(branch);
    SELECT_LIST_RESPONSIVE.items = selectList;


    
    let list: any[] = [];

    selectList.forEach((el: any) => {        
        list.push({ id: el.id, text: el.text, textLabel: el.text, class: `${section === el.id ? 'selected' : ''} list-item`, icon: el.icon, iconWidth: el.iconWidth, iconHeight: el.iconHeight });
    })

    //Remove pending attendance module, after 25 days from February 25
    if(daysLeft <= 0){
        list = list.filter((element) => element.id !== 1);
    }

    const sectionChange = (index: number) => {
        changeSection(index);
    }


    return (
        <div className="menu">
            <ModalQR modalQR={modalQR} branchId={branch}></ModalQR>
            <ul>
                <div className="container-desktop">
                    <MenuProfile showQR={() => showQR(!modalQR)}></MenuProfile>
                </div>

                <Grid item display={{ xs: "none", sm: "none", md: "block" }}>
                    {list.map((item: any) => (
                        <button key={item.text} type="button" onClick={() => sectionChange(item.id)} className={item.class}>
                            <Grid container justifyContent="space-between">
                                <Typography align="left">
                                    <Grid container alignItems={"center"}>
                                        <Icon name={item.icon} width={item.iconWidth} height={item.iconHeight} color={item.class === "selected list-item" ? '#f82e4b' : '#747474'} />
                                        <span className="ml-1">{item.text}</span>
                                    </Grid>
                                </Typography>
                                <Typography align="right" className="icon-right">
                                    {
                                        item.class === "selected list-item" ?
                                            <ArrowBackIos fontSize="small" /> :
                                            < ArrowForwardIos fontSize="small" />
                                    }
                                </Typography>
                            </Grid>
                        </button>
                    ))}
                </Grid>

                <Grid item display={{ md: "none", xs: "block", sm: "block" }}>
                    <TabsMobile selectData={SELECT_LIST_RESPONSIVE} changeSection={(sectionChange: number) => changeSection(sectionChange)} section={section}></TabsMobile>
                </Grid>
            </ul>
        </div>

    )
}